// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__BZj73","slideshow":"Carousel_slideshow__lWhyO","left":"Carousel_left__iTR6O","right":"Carousel_right__35gbf"};